import { render } from "./InternationalizationPage.vue?vue&type=template&id=301c484c&scoped=true"
import script from "./InternationalizationPage.vue?vue&type=script&lang=js"
export * from "./InternationalizationPage.vue?vue&type=script&lang=js"

import "./InternationalizationPage.vue?vue&type=style&index=0&id=301c484c&scoped=true&lang=css"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301c484c"]])

export default __exports__